import DbBaseObject from "@shared/DbBaseObject.js";

export default class ToolEntitlementItem extends DbBaseObject {
	ownerId: string = ""
	freeEntitledToolTypes: string[] = []
	freeToolTypeLimit: number = 0
	freeResultsViewLimit: number = 0
	freeResultsViewedCount: number = 0

	constructor(options = {}) {
		super(options);
		this.applyOptions(options)
	}
}
